import { JwtForgotPasswordPayload, JwtOTPSignInPayload, JwtResetPasswordKnownPayload, JwtResetPasswordPayload, JwtSignInPayload, JwtSignInSocials, JwtSignUpPayload, JwtSignUpSocials, JwtSocialsOtp } from '@auth/services/jwt/JwtAuthProvider';
import { User } from '@auth/user';
import { FuseAuthProviderState } from '@fuse/core/FuseAuthProvider/types/FuseAuthTypes';
import { createContext } from 'react';

export type JwtAuthContextType = FuseAuthProviderState<User> & {
	updateUser: (U: User) => Promise<Response>;
	signIn?: (credentials: JwtSignInPayload) => Promise<Response>;
	otpSignIn?: (credentials: JwtOTPSignInPayload) => Promise<Response>;
	signUp?: (U: JwtSignUpPayload) => Promise<Response>;
	signOut?: (options?: { redirect?: boolean }) => void;
	refreshToken?: () => Promise<string | Response>;
	forgotPassword?: (fp: JwtForgotPasswordPayload) => Promise<Response>;
	resetPassword?: (rp: JwtResetPasswordPayload) => Promise<Response>;
	resetKnownPassword?: (rp: JwtResetPasswordKnownPayload) => Promise<Response>;
	signInWithSocials?: (credentials: JwtSignInSocials) => Promise<Response>;
	signUpWithSocials?: (credentials: JwtSignUpSocials) => Promise<Response>;
	socialOtpSignIn?: (credentials: JwtSocialsOtp) => Promise<Response>;
	panelLogin?: (flag: string) => Promise<Response>;
};

const JwtAuthContext = createContext<JwtAuthContextType | undefined>(undefined);

export default JwtAuthContext;
